import React from 'react';
import { RefreshStudyPlanFormModalProps } from './types';
import style from './style.module.scss';
import cx from 'classnames';
import { SecondaryButton } from '@magoosh/lib/button';
import { PremiumBadge } from '@magoosh/lib/info_badges';
import { Modal } from 'react-bootstrap';
import { useUserContext } from '@magoosh/context/user_context';
import { paths } from 'config/path_helpers';

export const RefreshStudyPlanFormModal: React.FC<RefreshStudyPlanFormModalProps> = (props) => {
  const { isOpen, closeModal, refresh } = props;
  const { adaptivePrepData } = useUserContext();

  return (
    <Modal className={style.refreshStudyPlanFormModal} show={isOpen} onHide={() => closeModal()}>
      <Modal.Header className={cx(style.header, 'u-padding-B-n')} closeButton>
        <span className="d-flex justify-content-between align-items-center u-padding-T-m u-padding-B-xs">
          <h3 className="u-margin-A-n">
            <strong>Check for Recommendations</strong>
          </h3>
          {adaptivePrepData.isTrial && <PremiumBadge className={'u-margin-H-xs'} />}
        </span>
        <p>
          Based on your latest performance, updated curriculum and practice recommendations may be available.
        </p>
      </Modal.Header>
      <Modal.Body className="u-padding-T-n">
        <div className={style.content}>
          <h4>What may change?</h4>
          <ul className="u-padding-L-m">
            <li>Topics</li>
            <li>Frequency and type of practice</li>
          </ul>
          <h4>What will stay the same?</h4>
          <ul className="u-padding-L-m">
            {/* <li>Self-selected topics</li> */}
            {/* <li>Tutor recommendations</li> */}
            <li>Your completed activities</li>
          </ul>
        </div>

        {adaptivePrepData.isTrial ? (
          <SecondaryButton
            onClick={() => {
              window.open(paths.plans());
              closeModal();
            }}
            block={true}
            className="u-margin-T-m">
            Upgrade
          </SecondaryButton>
        ) : (
          <SecondaryButton
            onClick={() => {
              refresh();
              closeModal();
            }}
            block={true}
            className="u-margin-T-m">
            Refresh My Study Plan
          </SecondaryButton>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default RefreshStudyPlanFormModal;
